import { render, staticRenderFns } from "./_customersSection.vue?vue&type=template&id=d89a609c&scoped=true&"
import script from "./_customersSection.vue?vue&type=script&lang=js&"
export * from "./_customersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a609c",
  null
  
)

export default component.exports